// extracted by mini-css-extract-plugin
module.exports = {"label":"_1fb00b78"};